import { HomepageBannerCarousel } from '@/components/HomepageBannerCarousel';
import { GuidesCarousel } from '@/components/guides/GuidesCarousel';
import type { Guides } from '@/types/guides';

export function HeroBanner({
    showGuides,
    locale,
    initialGuides,
    littleVeniceSpotlightEnabled,
}: {
    showGuides: boolean;
    locale: string;
    initialGuides?: Guides;
    littleVeniceSpotlightEnabled?: boolean;
}) {
    return (
        <GuidesCarousel showGuidesCarousel={showGuides} initialGuides={initialGuides}>
            <HomepageBannerCarousel
                locale={locale}
                littleVeniceSpotlightEnabled={littleVeniceSpotlightEnabled}
            />
        </GuidesCarousel>
    );
}
